export default __webpack_public_path__ + "static/media/error-icon.a7c995c5.svg";